import React from 'react'

import { setIsUserGuideModalOpen } from '../../store/ui/uiSlice'
import Heading from '../Heading/Heading'
import Modal from '../Modal/Modal'
import * as Styled from './styles'
import { useAppDispatch, useAppSelector } from '../../hooks'

interface Props {
  userGuideHTML: string | TrustedHTML
}

const UserGuide: React.FC<Props> = ({ userGuideHTML }) => {
  const dispatch = useAppDispatch()

  const { content } = useAppSelector((state) => state.init)
  const { isUserGuideModalOpen } = useAppSelector((state) => state.ui)

  return (
    <Modal
      isOpen={isUserGuideModalOpen}
      onRequestClose={() => {
        dispatch(setIsUserGuideModalOpen(false))
      }}
      contentLabel={content?.modals?.userGuide?.title} // only for screenreaders
    >
      <Styled.ModalUserGuide>
        <Heading level={2}>{content?.modals?.userGuide?.title}</Heading>
        <div dangerouslySetInnerHTML={{ __html: userGuideHTML }}></div>
      </Styled.ModalUserGuide>
    </Modal>
  )
}

export default UserGuide
